exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lang[data-v-478764a7]{width:100%}.lang[data-v-478764a7] .el-form-item__content{width:79%}", ""]);

// exports
